module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "block"
  }, _vm._l((_vm.news.slice().reverse()), function(item) {
    return _c('el-timeline', {
      key: item.idNews,
      attrs: {
        "label": item.headLine,
        "value": item.idGroupCompany
      }
    }, [_c('el-timeline-item', {
      attrs: {
        "timestamp": item.dateLine,
        "placement": "top"
      }
    }, [_c('el-card', [_c('h4', [_vm._v(_vm._s(item.headLine))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(item.body))])])], 1)], 1)
  }), 1)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5bfe0673"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/News.vue
// module id = 634
// module chunks = 1